import { PaperClipOutlined, DeleteOutlined, CloseOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Col, Progress, Row } from 'antd';
import { Display, JustifyContent } from 'src/styles';

import { MButton } from '../FormComponents/MButton/MButton';

import * as Styles from './MUpload.styles';

interface MUploadFileProps {
  id: string;
  name: string;
  onCancel?: (id: string) => void;
  onDelete?: (id: string) => void;
  deleteLabel?: string;
  danger?: boolean;
  percent?: number;
  testId?: string;
}

export const MUploadFile = ({
  id,
  name,
  percent,
  onCancel,
  onDelete,
  danger = false,
  deleteLabel,
  testId,
}: MUploadFileProps) => {
  const findProgressStatus = () => {
    if (danger) {
      return 'exception';
    }

    if (percent && percent < 100) {
      return 'active';
    }

    if (percent === 100) {
      return 'success';
    }

    return 'normal';
  };

  return (
    <Row>
      <Col span={24} className={Styles.uploadFile}>
        <Row className={Styles.iconAndEditButton}>
          <Col span={24}>
            <Row className={cx(Display.flex, JustifyContent.spaceBetween)} align='middle'>
              <Col>
                <PaperClipOutlined className={Styles.icon} />
                <span className={Styles.filename(danger)} data-testid={testId + '-filename'}>
                  {name}
                </span>
              </Col>
              {onCancel && (
                <Col>
                  <MButton
                    type='tertiary'
                    onClick={() => onCancel(id)}
                    className={Styles.cancelButton}
                    testId={testId + '-cancel'}>
                    Cancel
                    <CloseOutlined />
                  </MButton>
                </Col>
              )}
            </Row>
          </Col>
          {percent && (
            <Col span={24}>
              <Progress percent={percent} status={findProgressStatus()} showInfo />
            </Col>
          )}
        </Row>
      </Col>
      {onDelete && (
        <Col span={24} className={Styles.removeButtonContainer}>
          <MButton type='tertiary' danger onClick={() => onDelete(id)} testId={`${testId}-remove-btn`}>
            {deleteLabel ? deleteLabel : 'Remove'}
            <DeleteOutlined />
          </MButton>
        </Col>
      )}
    </Row>
  );
};
